import React from 'react';

const newlineToBr = {
  type: 'postProcessor',
  name: 'reactNewlineToBr',
  process(value) {
    if (typeof value !== 'string') return value;
    const lines = value.split('\n');
    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));
  },
};

export default newlineToBr;
